import React, { useState } from 'react';
import { ArrowRight, Sparkles, Check, AlertTriangle } from 'lucide-react';

const BeforeAfterData = () => {
  const [showClean, setShowClean] = useState(false);

  const messyData = [
    { fullName: 'Lily - Rose Depp', email: 'LILYRO_4@OUTLOOK.COM', phone: '+01 (521) 819-6001', revenue: '$50k', state: 'GA', country: 'US', lifecycle: 'lead' },
    { fullName: 'Millie - Bobby Brown', email: 'MILLIEBOBBYBROWN.433@YAHOO.COM', phone: '+01 (711) 615-5940', revenue: '100000', state: 'WI', country: 'usa', lifecycle: 'CUSTOMER' },
    { fullName: 'Selena Gomez', email: 'selenagomez@example.com', phone: '952.553.4192', revenue: '2.5M', state: 'Michigan', country: 'United States', lifecycle: 'opportunity' },
    { fullName: 'Lupita  Nyongo', email: 'lupita_28@company.co', phone: '+1-576-724-2388 ext 279', revenue: '$75,000', state: 'NL', country: 'CA', lifecycle: 'Lead' },
    { fullName: 'Sandra - Bullock', email: 'sandrabullock.164@hotmail.com', phone: '869-784-8018 x283', revenue: '500K', state: 'IA', country: 'america', lifecycle: 'subscriber' },
    { fullName: 'Trevor Noah', email: 'trevornoah..892@business.ai', phone: '+15252880957', revenue: '1,500,000', state: 'NM', country: 'U.S.A.', lifecycle: 'MQL' },
    { fullName: 'Robert - Downey Jr', email: 'robertdowneyjr@outlook..com', phone: '838.346.5787', revenue: '$10M', state: 'Ontario', country: 'canada', lifecycle: 'Customer' },
    { fullName: 'Zendaya Coleman', email: 'zendayacoleman..928@gmail.com', phone: '+1 547-382-9973', revenue: '250k', state: 'IL', country: 'US', lifecycle: 'sql' },
  ];

  const cleanData = [
    { fullName: 'Lily Rose Depp', firstName: 'Lily Rose', lastName: 'Depp', email: 'lilyro_4@outlook.com', phone: '+1 521 819 6001', revenue: 50000, state: 'Georgia', country: 'United States', lifecycle: 'Lead' },
    { fullName: 'Millie Bobby Brown', firstName: 'Millie Bobby', lastName: 'Brown', email: 'milliebobbybrown.433@yahoo.com', phone: '+1 711 615 5940', revenue: 100000, state: 'Wisconsin', country: 'United States', lifecycle: 'Customer' },
    { fullName: 'Selena Gomez', firstName: 'Selena', lastName: 'Gomez', email: 'selenagomez@example.com', phone: '+1 952 553 4192', revenue: 2500000, state: 'Michigan', country: 'United States', lifecycle: 'Opportunity' },
    { fullName: 'Lupita Nyongo', firstName: 'Lupita', lastName: 'Nyongo', email: 'lupita_28@company.co', phone: '+1 576 724 2388', revenue: 75000, state: 'Newfoundland and Labrador', country: 'Canada', lifecycle: 'Lead' },
    { fullName: 'Sandra Bullock', firstName: 'Sandra', lastName: 'Bullock', email: 'sandrabullock.164@hotmail.com', phone: '+1 869 784 8018', revenue: 500000, state: 'Iowa', country: 'United States', lifecycle: 'Subscriber' },
    { fullName: 'Trevor Noah', firstName: 'Trevor', lastName: 'Noah', email: 'trevornoah.892@business.ai', phone: '+1 525 288 0957', revenue: 1500000, state: 'New Mexico', country: 'United States', lifecycle: 'MQL' },
    { fullName: 'Robert Downey Jr', firstName: 'Robert', lastName: 'Downey Jr', email: 'robertdowneyjr@outlook.com', phone: '+1 838 346 5787', revenue: 10000000, state: 'Ontario', country: 'Canada', lifecycle: 'Customer' },
    { fullName: 'Zendaya Coleman', firstName: 'Zendaya', lastName: 'Coleman', email: 'zendayacoleman.928@gmail.com', phone: '+1 547 382 9973', revenue: 250000, state: 'Illinois', country: 'United States', lifecycle: 'SQL' },
  ];

  const highlightIssue = (text) => {
    // Highlight common issues in messy data
    const issues = [
      /\s-\s/g,           // " - " in names
      /\s{2,}/g,          // Multiple spaces
      /[A-Z]{5,}/g,       // ALL CAPS
      /\+01/g,            // Wrong country code
      /\.\./g,            // Double dots
      /\s@\s/g,           // Spaces around @
      /x\d+/g,            // Extensions
      /ext\s*\d+/gi,      // Extensions
      /\(\d+\)/g,         // Parentheses in phone
      /\d+-\d+-\d+/g,     // Dashes in phone
      /\d+\.\d+\.\d+/g,   // Dots in phone
    ];
    
    let hasIssue = false;
    for (const pattern of issues) {
      if (pattern.test(text)) {
        hasIssue = true;
        break;
      }
    }
    
    return hasIssue;
  };

  const formatRevenue = (value) => {
    if (typeof value === 'number') {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
    }
    return value;
  };

  return (
    <div className="w-full max-w-7xl mx-auto">
      {/* Toggle Button */}
      <div className="flex justify-center mb-8">
        <div className="inline-flex items-center bg-slate-100 rounded-full p-1.5">
          <button
            onClick={() => setShowClean(false)}
            className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-300 ${
              !showClean 
                ? 'bg-white text-slate-900 shadow-md' 
                : 'text-slate-600 hover:text-slate-900'
            }`}
          >
            <span className="flex items-center gap-2">
              <AlertTriangle className="w-4 h-4 text-amber-500" />
              Before
            </span>
          </button>
          <button
            onClick={() => setShowClean(true)}
            className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-300 ${
              showClean 
                ? 'bg-indigo-600 text-white shadow-md' 
                : 'text-slate-600 hover:text-slate-900'
            }`}
          >
            <span className="flex items-center gap-2">
              <Sparkles className="w-4 h-4" />
              After
            </span>
          </button>
        </div>
      </div>

      {/* Data Display */}
      <div className="relative overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-xl">
        {/* Header Bar */}
        <div className={`px-6 py-4 border-b transition-colors duration-500 ${
          showClean 
            ? 'bg-gradient-to-r from-indigo-600 to-indigo-500' 
            : 'bg-gradient-to-r from-slate-700 to-slate-600'
        }`}>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className={`w-3 h-3 rounded-full ${showClean ? 'bg-green-400' : 'bg-amber-400'}`}></div>
              <span className="text-white font-medium">
                {showClean ? 'Cleaned Data' : 'Raw Data'}
              </span>
            </div>
            <div className="flex items-center gap-2 text-white/80 text-sm">
              {showClean ? (
                <>
                  <Check className="w-4 h-4 text-green-300" />
                  <span>CRM Ready</span>
                </>
              ) : (
                <>
                  <AlertTriangle className="w-4 h-4 text-amber-300" />
                  <span>Needs Cleaning</span>
                </>
              )}
            </div>
          </div>
        </div>

        {/* Table Container */}
        <div className="overflow-x-auto">
          {!showClean ? (
            /* Messy Data Table */
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-slate-50 border-b border-slate-200">
                  <th className="px-3 py-3 text-left font-semibold text-slate-700 whitespace-nowrap">Full Name</th>
                  <th className="px-3 py-3 text-left font-semibold text-slate-700 whitespace-nowrap">Email</th>
                  <th className="px-3 py-3 text-left font-semibold text-slate-700 whitespace-nowrap">Phone</th>
                  <th className="px-3 py-3 text-left font-semibold text-slate-700 whitespace-nowrap">Revenue</th>
                  <th className="px-3 py-3 text-left font-semibold text-slate-700 whitespace-nowrap">State</th>
                  <th className="px-3 py-3 text-left font-semibold text-slate-700 whitespace-nowrap">Country</th>
                  <th className="px-3 py-3 text-left font-semibold text-slate-700 whitespace-nowrap">Lifecycle</th>
                </tr>
              </thead>
              <tbody>
                {messyData.map((row, idx) => (
                  <tr key={idx} className="border-b border-slate-100 hover:bg-slate-50/50 transition-colors">
                    <td className="px-3 py-3 whitespace-nowrap">
                      <span className={highlightIssue(row.fullName) ? 'bg-amber-100 text-amber-800 px-1.5 py-0.5 rounded' : ''}>
                        {row.fullName}
                      </span>
                    </td>
                    <td className="px-3 py-3 font-mono text-xs whitespace-nowrap">
                      <span className={highlightIssue(row.email) || row.email === row.email.toUpperCase() ? 'bg-amber-100 text-amber-800 px-1.5 py-0.5 rounded' : ''}>
                        {row.email}
                      </span>
                    </td>
                    <td className="px-3 py-3 font-mono text-xs whitespace-nowrap">
                      <span className="bg-amber-100 text-amber-800 px-1.5 py-0.5 rounded">
                        {row.phone}
                      </span>
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      <span className="bg-amber-100 text-amber-800 px-1.5 py-0.5 rounded">
                        {row.revenue}
                      </span>
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      <span className={row.state.length <= 2 ? 'bg-amber-100 text-amber-800 px-1.5 py-0.5 rounded' : ''}>
                        {row.state}
                      </span>
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      <span className="bg-amber-100 text-amber-800 px-1.5 py-0.5 rounded">
                        {row.country}
                      </span>
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      <span className="bg-amber-100 text-amber-800 px-1.5 py-0.5 rounded">
                        {row.lifecycle}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            /* Clean Data Table */
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-indigo-50 border-b border-indigo-100">
                  <th className="px-3 py-3 text-left font-semibold text-indigo-900 whitespace-nowrap">Full Name</th>
                  <th className="px-3 py-3 text-left font-semibold text-indigo-900 whitespace-nowrap">
                    <span className="flex items-center gap-1">
                      First Name
                      <span className="text-xs font-normal text-indigo-500 bg-indigo-100 px-1.5 py-0.5 rounded">new</span>
                    </span>
                  </th>
                  <th className="px-3 py-3 text-left font-semibold text-indigo-900 whitespace-nowrap">
                    <span className="flex items-center gap-1">
                      Last Name
                      <span className="text-xs font-normal text-indigo-500 bg-indigo-100 px-1.5 py-0.5 rounded">new</span>
                    </span>
                  </th>
                  <th className="px-3 py-3 text-left font-semibold text-indigo-900 whitespace-nowrap">Email</th>
                  <th className="px-3 py-3 text-left font-semibold text-indigo-900 whitespace-nowrap">Phone</th>
                  <th className="px-3 py-3 text-left font-semibold text-indigo-900 whitespace-nowrap">Revenue</th>
                  <th className="px-3 py-3 text-left font-semibold text-indigo-900 whitespace-nowrap">State</th>
                  <th className="px-3 py-3 text-left font-semibold text-indigo-900 whitespace-nowrap">Country</th>
                  <th className="px-3 py-3 text-left font-semibold text-indigo-900 whitespace-nowrap">Lifecycle</th>
                </tr>
              </thead>
              <tbody>
                {cleanData.map((row, idx) => (
                  <tr key={idx} className="border-b border-indigo-50 hover:bg-indigo-50/50 transition-colors">
                    <td className="px-3 py-3 text-slate-700 whitespace-nowrap">{row.fullName}</td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      <span className="bg-green-100 text-green-800 px-1.5 py-0.5 rounded">
                        {row.firstName}
                      </span>
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      <span className="bg-green-100 text-green-800 px-1.5 py-0.5 rounded">
                        {row.lastName}
                      </span>
                    </td>
                    <td className="px-3 py-3 font-mono text-xs whitespace-nowrap">
                      <span className="bg-green-100 text-green-800 px-1.5 py-0.5 rounded">
                        {row.email}
                      </span>
                    </td>
                    <td className="px-3 py-3 font-mono text-xs whitespace-nowrap">
                      <span className="text-slate-700">{row.phone}</span>
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      <span className="bg-green-100 text-green-800 px-1.5 py-0.5 rounded font-medium">
                        {formatRevenue(row.revenue)}
                      </span>
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      <span className="bg-green-100 text-green-800 px-1.5 py-0.5 rounded">
                        {row.state}
                      </span>
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      <span className="bg-green-100 text-green-800 px-1.5 py-0.5 rounded">
                        {row.country}
                      </span>
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      <span className="bg-green-100 text-green-800 px-1.5 py-0.5 rounded">
                        {row.lifecycle}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Footer Stats */}
        <div className={`px-6 py-4 border-t transition-colors duration-500 ${
          showClean ? 'bg-indigo-50 border-indigo-100' : 'bg-slate-50 border-slate-200'
        }`}>
          <div className="flex flex-wrap items-center justify-between gap-4 text-sm">
            {showClean ? (
              <>
                <div className="flex items-center gap-4 flex-wrap">
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-green-500"></div>
                    <span className="text-slate-600">States/Countries standardized</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-indigo-500"></div>
                    <span className="text-slate-600">Names split</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-emerald-500"></div>
                    <span className="text-slate-600">Emails validated</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-amber-500"></div>
                    <span className="text-slate-600">Revenue normalized</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-purple-500"></div>
                    <span className="text-slate-600">Lifecycle cleaned</span>
                  </div>
                </div>
                <div className="flex items-center gap-2 text-green-600 font-medium">
                  <Check className="w-4 h-4" />
                  Ready for import
                </div>
              </>
            ) : (
              <>
                <div className="flex items-center gap-4 flex-wrap">
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-amber-500"></div>
                    <span className="text-slate-600">8 rows with issues</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-red-500"></div>
                    <span className="text-slate-600">Inconsistent formats</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-orange-500"></div>
                    <span className="text-slate-600">Mixed lifecycle values</span>
                  </div>
                </div>
                <button 
                  onClick={() => setShowClean(true)}
                  className="flex items-center gap-2 text-indigo-600 font-medium hover:text-indigo-700 transition-colors"
                >
                  See cleaned version
                  <ArrowRight className="w-4 h-4" />
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BeforeAfterData;
